import React, { useContext, useEffect, useState } from 'react';

import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid'
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import ArchiveItemButton from '../_common/ArchiveItemButton';
import FireDataContext from '../../../services/firebase/FireDataContext';
import { formatTimeStamp } from '../../../app/common/ui/DateTools';
import getStateColour from '../../../app/colours';
import Spacer from '../../../app/common/ui/Spacer';

const MemberBookingCard = ({ booking }) => {
    const db = useContext(FireDataContext);

    const [courtCase, setCourtCase] = useState();

    useEffect(() => {
        db.get({ path: `organizations/${booking.referral.organizationId}/cases/${booking.referral.courtCaseId}` })
            .then (data => {
                setCourtCase(data);
            })
    }, [db, booking.referral.organizationId, booking.referral.courtCaseId]);

    const status = !booking.completed ? 'live' : 'completed';

    return (
        <Paper style={{ padding: '1rem', marginBottom: '1rem' }}>
            <Grid container spacing={1}>
                <Grid item><Typography variant="button" color="textSecondary">BOOKING</Typography> </Grid>
                <Grid item style={{ marginLeft: 'auto' }}><Chip label={status} size="small" style={{ backgroundColor: getStateColour(status), color: 'white' }} /></Grid>
            </Grid>

            <Typography variant="subtitle2">{booking.request?.organization}</Typography>
            <Typography variant="subtitle2" color="textSecondary">Reference {booking.referral?.bookingReference}</Typography>
            <Typography variant="subtitle2" color="textSecondary">Court Case Number {courtCase?.courtCaseNumber}</Typography>
            <Spacer space='0.5rem' />
            <Typography variant="body2">{courtCase?.serviceUserName || '?'} in {booking.referral.location.name}</Typography>
            <Spacer space='0.5rem' />
            <Typography variant="caption">{formatTimeStamp(booking.completed?.ts || booking.created?.ts)}</Typography>
            <Spacer space='0.5rem' />
            <Grid container spacing={1}>
                {/* <Grid item>
                    <Link href={`/casework/bookings/${booking.id}`} color="primary">View Booking</Link>
                </Grid> */}
                <Grid item>
                    <Link href={`/casework/timesheets/${booking.id}`} color="primary">{status === 'completed' ? 'View' : 'Edit'} Invoice</Link>
                </Grid>
                <Grid item style={{ marginLeft: 'auto' }}>
                    <ArchiveItemButton doc={booking} docType="booking" />
                </Grid>
            </Grid>
        </Paper>
    );
}

export default MemberBookingCard;